export const GET_CAMPAIGNS_BY_STATUS        = "GET_CAMPAIGNS_BY_STATUS";
export const GET_CAMPAIGN_BY_HANDLE         = "GET_CAMPAIGN_BY_HANDLE";
export const GET_CAMPAIGNS_BY_COMMITED      = "GET_CAMPAIGNS_BY_COMMITED";
export const GET_CAMPAIGNS_BY_CLAIMABLE     = "GET_CAMPAIGNS_BY_CLAIMABLE";
export const SET_CAMPAIGN_ACTIVE            = "SET_CAMPAIGN_ACTIVE";
